export const SET_ERRORS = 'SET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const SET_LOADER_SECONDARY = 'SET_LOADER_SECONDARY';
export const SET_LOADER = 'SET_LOADER';
export const CLEAR_LOADER = 'CLEAR_LOADER';

export const SET_MENU_LOADER = 'SET_MENU_LOADER';
export const CLEAR_MENU_LOADER = 'CLEAR_MENU_LOADER';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_DECODED_TOKEN = 'SET_CURRENT_USER_DECODED_TOKEN';
export const LOG_OUT = 'LOG_OUT';
export const SET_STATUS = 'SET_STATUS';
export const SET_FORGOT_MOBILE = 'SET_FORGOT_MOBILE';
export const SET_CALLING_INFO = 'SET_CALLING_INFO';
export const SET_TWILIO_TOKEN = 'SET_TWILIO_TOKEN';

export const SET_PLACE_ID = 'SET_PLACE_ID';
export const SET_PLACE_ID_MARKER = 'SET_PLACE_ID_MARKER';
export const GET_MARKER_POSITION = 'GET_MARKER_POSITION';
export const GET_OPEN_RESTAURANT_STATUS = 'GET_OPEN_RESTAURANT_STATUS';

export const UPDATE_SUBSCRIPTION_TYPE = 'UPDATE_SUBSCRIPTION_TYPE';
export const SET_DELIVERY_PERSON_DETAILS = 'SET_DELIVERY_PERSON_DETAILS';

/********************************
 * @DESC NOTIFICATION COUNT
 *******************************/
export const NOTIFICATION_COUNT = 'NOTIFICATION_COUNT';

/*********************************
 * @DESC OVERLAY SCREEN REDUCERS
 *********************************/
export const CUS_BUSI_OVERLAY = 'CUS_BUSI_OVERLAY';

/*********************************
 * @DESC DATE FILTERS REDUCERS
 *********************************/
export const FILTER_DATE_VALUE = 'FILTER_DATE_VALUE';

/******************************
 * @DESC CHATING REDUCERS
 *****************************/
export const GET_MULTIPLE_CHAT_INFO = 'GET_MULTIPLE_CHAT_INFO';
export const UPDATE_MULTIPLE_CHAT_INFO = 'UPDATE_MULTIPLE_CHAT_INFO';
export const GET_CHAT_INFO = 'GET_CHAT_INFO';
export const GET_ADMIN_CHAT_INFO = 'GET_ADMIN_CHAT_INFO';
export const UPDATE_CHAT_INFO = 'UPDATE_CHAT_INFO';
export const UPDATE_ADMIN_CHAT_INFO = 'UPDATE_ADMIN_CHAT_INFO';
export const UPDATE_ADMIN_MULTIPLE_CHAT_INFO =
  'UPDATE_ADMIN_MULTIPLE_CHAT_INFO';
export const GET_DINER_CHAT_DATA_ADMIN = 'GET_DINER_CHAT_DATA_ADMIN';
export const GET_EVENT_CHAT_DATA_ADMIN = 'GET_EVENT_CHAT_DATA_ADMIN';
export const GET_ORDER_CHAT_DATA_ADMIN = 'GET_ORDER_CHAT_DATA_ADMIN';
export const GET_VENDOR_CHAT_DATA_ADMIN = 'GET_VENDOR_CHAT_DATA_ADMIN';
export const GET_SCAN_AND_PAY_REPORT_VENDOR = 'GET_SCAN_AND_PAY_REPORT_VENDOR';
export const GET_ADMIN_ITEM_SUMMARY = 'GET_ADMIN_ITEM_SUMMARY';
export const GET_ADMIN_ITEM_VENDOR = 'GET_ADMIN_ITEM_VENDOR';
export const GET_ALL_SEATING_VENDOR = 'GET_ALL_SEATING_VENDOR';
export const GET_SEATING_PENDING_VENDOR = 'GET_SEATING_PENDING_VENDOR';
export const GET_EVENT_VENDOR = 'GET_EVENT_VENDOR';

/***************************************************************
 * @DESC Onboarding Process Reducers Type
 **************************************************************/
export const SET_RESTAURANT_DETAILS = 'SET_RESTAURANT_DETAILS';
export const SET_RESTAURANT_SUBSCRIPTION_DETAILS =
  'SET_RESTAURANT_SUBSCRIPTION_DETAILS';

// NOTIFICATIONS
export const GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS';
export const GET_SINGLE_NOTIFICATION = 'GET_SINGLE_NOTIFICATION';
export const SET_NOTIFICATION_PAGE_INFO = 'SET_NOTIFICATION_PAGE_INFO';

//Curb Side Section
export const SET_CURBSIDE_LOCATION = 'SET_CURBSIDE_LOCATION';
export const SET_CURBSIDE_LOCATION_ARR = 'SET_CURBSIDE_LOCATION_ARR';
export const SET_FASTFOOD_CURBSIDE_LOCATION_ARR =
  'SET_FASTFOOD_CURBSIDE_LOCATION_ARR';
export const SET_MULTISERVICE_CURBSIDE_LOCATION_ARR =
  'SET_MULTISERVICE_CURBSIDE_LOCATION_ARR';
export const GET_FILTER_TABLE_DATA = 'GET_FILTER_TABLE_DATA';

/************************************************************
 * @DESC All Category Reducers
 ***********************************************************/
export const ACCESSIBILITY_TYPE = 'ACCESSIBILITY_TYPE';
export const DRESS_CODE_TYPE = 'DRESS_CODE_TYPE';
export const PARKING_TYPE = 'PARKING_TYPE';
export const PAYMENT_METHOD_TYPE = 'PAYMENT_METHOD_TYPE';
export const PET_ALLOWANCE_TYPE = 'PET_ALLOWANCE_TYPE';
export const RESTAURANT_TYPE = 'RESTAURANT_TYPE';
export const RESTAURANT_CHAIN = 'RESTAURANT_CHAIN';
export const RESTAURANT_FEATURES = 'RESTAURANT_FEATURES';
export const LOCATED_INSIDE = 'LOCATED_INSIDE';
export const POINT_OF_SALE = 'POINT_OF_SALE';
export const HEALTH_ENTRY_POINT = 'HEALTH_ENTRY_POINT';
export const HEALTH_INSIDE_FACILITY = 'HEALTH_INSIDE_FACILITY';
export const HEALTH_EMPLOYEES = 'HEALTH_EMPLOYEES';
export const HEALTH_FOOD_HANDLE = 'HEALTH_FOOD_HANDLE';
export const HEALTH_AND_SAFETY = 'HEALTH_AND_SAFETY';
export const OTHER_FEATURES = 'OTHER_FEATURES';
export const SERVICES_OFFERED = 'SERVICES_OFFERED';
export const FOOD_CATEGORY = 'FOOD_CATEGORY';
export const FOOD_TYPE = 'FOOD_TYPE';
export const LIQUORS = 'LIQUORS';
export const CUISINES = 'CUISINES';
export const SEATING_AREA = 'SEATING_AREA';
export const ALLERGY_INFORMATION = 'ALLERGY_INFORMATION';
export const TAGS_INFORMATION = 'TAGS_INFORMATION';
export const UOM_INFORMATION = 'UOM_INFORMATION';
export const BEVERAGES_TYPE = 'BEVERAGES_TYPE';
export const CATEGORY_CLASSIFICATION = 'CATEGORY_CLASSIFICATION';
export const MAJOR_CLASSIFICATION = 'MAJOR_CLASSIFICATION';
export const HEALTH_TAGS = 'HEALTH_TAGS';

// NEW CATEGORY IMPLEMENTATION
export const ALL_CATEGORY = 'ALL_CATEGORY';
export const GET_ALL_CATEGORY = 'GET_ALL_CATEGORY';

/************************************************************
 * @DESC ALL OFFERS AND EVENTS REDUCERS
 ***********************************************************/
export const GET_VENDOR_ALL_OFFERS = 'GET_VENDOR_ALL_OFFERS';
export const GET_VENDOR_ALL_EVENTS = 'GET_VENDOR_ALL_EVENTS';
export const GET_ONLINE_VIEW_EVENT = 'GET_ONLINE_VIEW_EVENT';
export const GET_EVENT_SUMMARY = 'GET_EVENT_SUMMARY';
export const GET_OFFER_VENDOR = 'GET_OFFER_VENDOR';
export const GET_OFFERS_ACTIVITY = 'GET_OFFERS_ACTIVITY';
export const GET_OFFER_SUMMARY = 'GET_OFFER_SUMMARY';
export const GET_ADMIN_OFFER_VENDOR = 'GET_ADMIN_OFFER_VENDOR';
export const GET_ADMIN_SEATING_ACTIVITY = 'GET_ADMIN_SEATING_ACTIVITY';
export const GET_ADMIN_SEATING_PENDING_ACTIVITY =
  'GET_ADMIN_SEATING_PENDING_ACTIVITY';
export const GET_ADMIN_SEATING_SUMMARY = 'GET_ADMIN_SEATING_SUMMARY';
export const GET_ADMIN_SEATING_VENDOR = 'GET_ADMIN_SEATING_VENDOR';
export const GET_ITEM_REPORT_VENDOR = 'GET_ITEM_REPORT_VENDOR';

export const GET_EXP_SUMMARY = 'GET_EXP_SUMMARY';
export const GET_EXP_VENDOR = 'GET_EXP_VENDOR';

/************************************************************
 * @DESC ALL VENDOR DINER REDUCERS
 ***********************************************************/
export const SET_DINER_DETAILS = 'SET_DINER_DETAILS';
export const GET_VENDOR_DINER = 'GET_VENDOR_DINER';
export const GET_PENDING_DINER = 'GET_PENDING_DINER';
export const GET_RESERVATION_DINER = 'GET_RESERVATION_DINER';
export const GET_HISTORY_DINER = 'GET_HISTORY_DINER';

/************************************************************
 * @DESC ALL VENDOR DINER COUNT REDUCERS
 ***********************************************************/
export const INC_SEATING_COUNT = 'INC_SEATING_COUNT';
export const DEC_SEATING_COUNT = 'DEC_SEATING_COUNT';

/************************************************************
 * @DESC VENDOR RESERVATION TIMING SLOTS REDUCERS
 ***********************************************************/
export const GET_RESERVATION_TIMING_SLOTS = 'GET_RESERVATION_TIMING_SLOTS';
export const GET_AVAILABLE_TABLE_DATA = 'GET_AVAILABLE_TABLE_DATA';

/************************************************************
 * @DESC ALL VENDOR RATINGS REVIEWS REDUCERS
 ***********************************************************/
export const GET_VENDOR_RATINGS_REVIEWS = 'GET_VENDOR_RATINGS_REVIEWS';
export const GET_VENDOR_RATINGS_COUNT = 'GET_VENDOR_RATINGS_COUNT';

/************************************************************
 * @DESC ALL USERS TICKETS REDUCERS
 ***********************************************************/
export const GET_VENDOR_USERS_TICKETS = 'GET_VENDOR_USERS_TICKETS';
export const GET_SINGLE_VENDOR_USERS_TICKETS =
  'GET_SINGLE_VENDOR_USERS_TICKETS';
export const GET_VENDOR_DINER_MOBILE = 'GET_VENDOR_DINER_MOBILE';
export const GET_ISSUE_SEATING_ADD_TICKET = 'GET_ISSUE_SEATING_ADD_TICKET';
export const GET_ISSUE_ORDERS_ADD_TICKET = 'GET_ISSUE_ORDERS_ADD_TICKET';
export const GET_ISSUE_OFFERS_ADD_TICKET = 'GET_ISSUE_OFFERS_ADD_TICKET';
export const GET_ISSUE_SCANPAY_ADD_TICKET = 'GET_ISSUE_SCANPAY_ADD_TICKET';
export const GET_ISSUE_EVENT_ADD_TICKET = 'GET_ISSUE_EVENT_ADD_TICKET';
export const GET_ISSUE_WALLET_ADD_TICKET = 'GET_ISSUE_WALLET_ADD_TICKET';
export const GET_ISSUE_RATINGREVIEW_ADD_TICKET =
  'GET_ISSUE_RATINGREVIEW_ADD_TICKET';
export const GET_VENDOR_DINER_ISSUES_CATEGORY =
  'GET_VENDOR_DINER_ISSUES_CATEGORY';
export const EDIT_VENDOR_USER_TICKETS_DETAILS =
  'EDIT_VENDOR_USER_TICKETS_DETAILS';
export const SET_VENDOR_TICKETS_USER_DETAILS =
  'SET_VENDOR_TICKETS_USER_DETAILS';
export const GET_VENDOR_ORDER_ITEM_LIST = 'GET_VENDOR_ORDER_ITEM_LIST';

/*************************************************************
 * @DESC ALL VENDOR ISSUES SUGGESTION
 *************************************************************/
export const GET_VENDOR_ISSUES_SUGGESTION = 'GET_VENDOR_ISSUES_SUGGESTION';
export const GET_ONE_ISSUES_SUGGESTION = 'GET_ONE_ISSUES_SUGGESTION';

/*************************************************************
 * @DESC ALL VENDOR ORDERING DASHBOARD
 *
 *************************************************************/
export const SET_ORDER_TIP = 'SET_ORDER_TIP';
export const SET_ORDER_DONATION = 'SET_ORDER_DONATION';
export const SELECTED_SUBSTITUTE_ITEM = 'SELECTED_SUBSTITUTE_ITEM';
export const UPDATE_ORDER_DATA_SOCKET = 'UPDATE_ORDER_DATA_SOCKET';
export const ORDER_ID = 'ORDER_ID';
export const GET_VENDOR_ALL_TAKEAWAY_ORDER = 'GET_VENDOR_ALL_TAKEAWAY_ORDER';
export const GET_VENDOR_ALL_CURBSIDE_ORDER = 'GET_VENDOR_ALL_CURBSIDE_ORDER';
export const GET_VENDOR_ALL_SKIPTHELINE_ORDER =
  'GET_VENDOR_ALL_SKIPTHELINE_ORDER';
export const GET_VENDOR_ALL_DINEIN_ORDER = 'GET_VENDOR_ALL_DINEIN_ORDER';
export const GET_VENDOR_ALL_BUFFET_ORDER = 'GET_VENDOR_ALL_BUFFET_ORDER';
export const GET_VENDOR_ALL_CATERING_ORDER = 'GET_VENDOR_ALL_CATERING_ORDER';
export const GET_VENDOR_ALL_DRIVETHRU_ORDER = 'GET_VENDOR_ALL_DRIVETHRU_ORDER';
export const GET_VENDOR_ALL_DELIVERY_ORDER = 'GET_VENDOR_ALL_DELIVERY_ORDER';

export const CREATE_ORDER_VENDOR = 'CREATE_ORDER_VENDOR';
export const FILTERED_MENU_ORDER = 'FILTERED_MENU_ORDER';
export const UPDATE_CART_FILTERED_MENU_ORDER =
  'UPDATE_CART_FILTERED_MENU_ORDER';

export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD';
export const UPDATE_PAYMENT_WALLET_DETAILS = 'UPDATE_PAYMENT_WALLET_DETAILS';
export const SUBSTITUTE_EXISTING_RECORDS = 'SUBSTITUTE_EXISTING_RECORDS';

export const CLEAR_CART_DATA = 'CLEAR_CART_DATA';
export const CLEAR_CART_DATA_USER_DATA = 'CLEAR_CART_DATA_USER_DATA';
export const GET_ALL_DEBIT_CREDIT_MEMO = 'GET_ALL_DEBIT_CREDIT_MEMO';
export const VIEW_MEMO_DETAILS = 'VIEW_MEMO_DETAILS';
export const APPLY_OFFER_VENDOR = 'APPLY_OFFER_VENDOR';

export const SET_VENDOR_ORDERING_CART_DATA = 'SET_VENDOR_ORDERING_CART_DATA';
export const UPDATE_VENDOR_ORDERING_CART_DATA =
  'UPDATE_VENDOR_ORDERING_CART_DATA';
export const SET_VENDOR_ORDERING_CART_DATA_QUANTITY =
  'SET_VENDOR_ORDERING_CART_DATA_QUANTITY';
export const UPDATE_SELECTED_CATEGORY_TAB = 'UPDATE_SELECTED_CATEGORY_TAB';
export const SUGGESTIONS_DATA = 'SUGGESTIONS_DATA';
export const SET_VENDOR_ORDERING_EDIT_DATA = 'SET_VENDOR_ORDERING_EDIT_DATA';

export const ADD_NEW_SELECTED_ITEM = 'ADD_NEW_SELECTED_ITEM';
export const ADD_NEW_EXISTING_RECORDS = 'ADD_NEW_EXISTING_RECORDS';

export const SET_ORDER_TYPE_DETAILS = 'SET_ORDER_TYPE_DETAILS';
export const CLEAR_ORDER_TYPE_DETAILS = 'CLEAR_ORDER_TYPE_DETAILS';

/*************************************************************
 * @DESC ALL ADMIN ACTIONS
 *************************************************************/

export const SUPERADMIN_ALL_USER_LIST = 'SUPERADMIN_ALL_USER_LIST';
export const SUPERADMIN_ALL_USER_STATS = 'SUPERADMIN_ALL_USER_STATS';
export const SUPERADMIN_ALL_USER_RANGE = 'SUPERADMIN_ALL_USER_RANGE';
export const SUPERADMIN_USER_ALL_DETAILS = 'SUPERADMIN_USER_ALL_DETAILS';
export const SUPERADMIN_USER_DETAILS_DATE_RANGE =
  'SUPERADMIN_USER_DETAILS_DATE_RANGE';
export const SA_USER_DETAILS_SEATING = 'SA_USER_DETAILS_SEATING';
export const SA_USER_DETAILS_ORDERING = 'SA_USER_DETAILS_ORDERING';
export const SA_USER_DETAILS_EVENTS = 'SA_USER_DETAILS_EVENTS';
export const SA_USER_DETAILS_WALLET = 'SA_USER_DETAILS_WALLET';
export const SA_USER_DETAILS_NOMINATIONS = 'SA_USER_DETAILS_NOMINATIONS';
export const SA_USER_DETAILS_FAVOURITES = 'SA_USER_DETAILS_FAVOURITES';
export const SA_USER_DETAILS_REVIEWS = 'SA_USER_DETAILS_REVIEWS';
export const SA_USER_DETAILS_REFERRAL = 'SA_USER_DETAILS_REFERRAL';
export const SA_USER_DETAILS_MISCELLANEOUS = 'SA_USER_DETAILS_MISCELLANEOUS';
export const SA_USER_DETAILS_USER_TICKETS = 'SA_USER_DETAILS_USER_TICKETS';
export const SA_USER_DETAILS_LIVE_STREAMING = 'SA_USER_DETAILS_LIVE_STREAMING';
export const SA_USER_DETAILS_VIDEO_CONTENT = 'SA_USER_DETAILS_VIDEO_CONTENT';
export const SA_USER_DETAILS_OFFERS = 'SA_USER_DETAILS_OFFERS';
export const SA_USER_DETAILS_EXPERIENCE = 'SA_USER_DETAILS_EXPERIENCE';
export const SA_USER_DETAILS_REELS = 'SA_USER_DETAILS_REELS';

export const SUPERADMIN_ALL_ACTIVE_VENDORS = 'SUPERADMIN_ALL_ACTIVE_VENDORS';
export const SUPERADMIN_ALL_PENDING_VENDORS = 'SUPERADMIN_ALL_PENDING_VENDORS';
export const SET_SELECT_DATE_RANGE = 'SET_SELECT_DATE_RANGE';
export const SUPERADMIN_VENDORS_SINGLE_REVIEW =
  'SUPERADMIN_VENDORS_SINGLE_REVIEW';

export const SUPERADMIN_VENDORS_OPEN_ISSUES = 'SUPERADMIN_VENDORS_OPEN_ISSUES';
export const SUPERADMIN_SINGLE_VENDORS_OPEN_ISSUES =
  'SUPERADMIN_SINGLE_VENDORS_OPEN_ISSUES';

export const EDITUSER_DATA_STEP1_HOME = 'EDITUSER_DATA_STEP1_HOME';
export const EDITUSER_DATA_STEP2_HOME = 'EDITUSER_DATA_STEP2_HOME';
export const EDITUSER_DATA_STEP3_HOME = 'EDITUSER_DATA_STEP3_HOME';
export const EDITUSER_DATA_STEP4_HOME = 'EDITUSER_DATA_STEP4_HOME';
export const EDITUSER_DATA_STEP1 = 'EDITUSER_DATA_STEP1';
export const EDITUSER_DATA_STEP2 = 'EDITUSER_DATA_STEP2';
export const EDITUSER_DATA_STEP3 = 'EDITUSER_DATA_STEP3';
export const EDITUSER_DATA_STEP4 = 'EDITUSER_DATA_STEP4';
export const SUPERADMIN_USER_DELETE = 'SUPERADMIN_USER_DELETE';
export const SUPERADMIN_USER_BLOCK = 'SUPERADMIN_USER_BLOCK';
export const SUPERADMIN_USER_BLOCK_HOME = 'SUPERADMIN_USER_BLOCK_HOME';
export const SUPERADMIN_USER_FLAG = 'SUPERADMIN_USER_FLAG';
export const SUPERADMIN_USER_FLAG_HOME = 'SUPERADMIN_USER_FLAG_HOME';
export const SUPERADMIN_USER_ARCHIVE = 'SUPERADMIN_USER_ARCHIVE';
export const SUPERADMIN_USER_ARCHIVE_HOME = 'SUPERADMIN_USER_ARCHIVE_HOME';
export const SUPERADMIN_USER_ISSUES_LIST = 'SUPERADMIN_USER_ISSUES_LIST';
export const SUPERADMIN_ADD_COMMENT_ISSUE = 'SUPERADMIN_ADD_COMMENT_ISSUE';

export const SUPERADMIN_UPDATE_TICKET_STATUS =
  'SUPERADMIN_UPDATE_TICKET_STATUS';
export const UPDATE_ADMIN_OFFER_STATUS = 'UPDATE_ADMIN_OFFER_STATUS';
export const SUPERADMIN_DELETE_OFFER = 'SUPERADMIN_DELETE_OFFER';

export const SUPERADMIN_CHANGE_STATUS_ISSUE_DETAIL =
  'SUPERADMIN_CHANGE_STATUS_ISSUE_DETAIL';

export const SUPERADMIN_USER_ISSUE_DETAIL = 'SUPERADMIN_USER_ISSUE_DETAIL';
export const USER_RESTAURANT_ACTIVITY = 'USER_RESTAURANT_ACTIVITY';
export const USER_OFFER_ACTIVITY = 'USER_OFFER_ACTIVITY';
export const USER_EVENT_ACTIVITY = 'USER_EVENT_ACTIVITY';
export const USER_STREAMING_ACTIVITY = 'USER_STREAMING_ACTIVITY';
export const USER_ITEM_ACTIVITY = 'USER_ITEM_ACTIVITY';
export const USER_TRACK_VIDEO = 'USER_TRACK_VIDEO';
export const USER_RESTAURANT_FAVOURITES = 'USER_RESTAURANT_FAVOURITES';
export const USER_CLOSE_WALLET_REQUESTS = 'USER_CLOSE_WALLET_REQUESTS';
export const USER_OFFER_FAVOURITES = 'USER_OFFER_FAVOURITES';
export const USER_EVENT_FAVOURITES = 'USER_EVENT_FAVOURITES';
export const USER_REELS_ACTIVITY = 'USER_REELS_ACTIVITY';
export const GET_GROUP_BY_FAVOURITES = 'GET_GROUP_BY_FAVOURITES';

/*************************************************************
 * @DESC SUPER ADMIN VENDOR ONBOARDING REDUCERS
 *************************************************************/
export const SUPERADMIN_ONBOARDING_REDUCERS = 'SUPERADMIN_ONBOARDING_REDUCERS';
export const SUPERADMIN_RESTAURANT_CHAIN = 'SUPERADMIN_RESTAURANT_CHAIN';
export const SUPERADMIN_ONBOARDING_SUCCESS = 'SUPERADMIN_ONBOARDING_SUCCESS';

export const SUPERADMIN_VENDOR_SEATING_DINER =
  'SUPERADMIN_VENDOR_SEATING_DINER';
export const SUPERADMIN_VENDOR_PENDING_DINER =
  'SUPERADMIN_VENDOR_PENDING_DINER';
export const SUPERADMIN_VENDOR_RESERVATION_DINER =
  'SUPERADMIN_VENDOR_RESERVATION_DINER';
export const SUPERADMIN_VENDOR_HISTORY_DINER =
  'SUPERADMIN_VENDOR_HISTORY_DINER';
export const SET_VENDOR_INFORMATION = 'SET_VENDOR_INFORMATION';
export const SET_MERCHANT_EDIT_INFO = 'SET_MERCHANT_EDIT_INFO';
export const SET_MERCHANT_EDIT_ACTION_TYPE = 'SET_MERCHANT_EDIT_ACTION_TYPE';
export const SUPERADMIN_ALL_OFFER_LIST = 'SUPERADMIN_ALL_OFFER_LIST';

// restaurant offers
export const SUPERADMIN_RESTAURANT_OFFER_LIST =
  'SUPERADMIN_RESTAURANT_OFFER_LIST';
export const GET_OFFER_DETAIL_FROM_ID = 'GET_OFFER_DETAIL_FROM_ID';
export const UPDATE_CAROUSEL_RESTAURANT_OFFER =
  'UPDATE_CAROUSEL_RESTAURANT_OFFER';

export const SUPERADMIN_RESTAURANT_DELETE_OFFER =
  'SUPERADMIN_RESTAURANT_DELETE_OFFER';
export const SUPERADMIN_GET_CITY_FROM_COUNTRY =
  'SUPERADMIN_GET_CITY_FROM_COUNTRY';
export const SUPERADMIN_GET_RESTAURANT_FROM_CITY_COUNTRY =
  'SUPERADMIN_GET_RESTAURANT_FROM_CITY_COUNTRY';

/// nomination
export const SUPERADMIN_CHANGE_NOMINATION_STATUS =
  'SUPERADMIN_CHANGE_NOMINATION_STATUS';
export const SUPERADMIN_GET_ALL_RESTAURANT_NOMINATIONS =
  'SUPERADMIN_GET_ALL_RESTAURANT_NOMINATIONS';

export const SUPERADMIN_GET_NOMINATION_ACTIVITY =
  'SUPERADMIN_GET_NOMINATION_ACTIVITY';

export const SUPERADMIN_VIEW_NOMINATION_RESTAURANT =
  'SUPERADMIN_VIEW_NOMINATION_RESTAURANT';

// REVIEWS
export const SUPERADMIN_VIEW_ALL_REVIEWS = 'SUPERADMIN_VIEW_ALL_REVIEWS';
export const SUPERADMIN_CHANGE_REVIEW_STATUS =
  'SUPERADMIN_CHANGE_REVIEW_STATUS';

export const SUPERADMIN_ADD_SUGGESTION = 'SUPERADMIN_ADD_SUGGESTION';
export const SUPERADMIN_ADD_ISSUES = 'SUPERADMIN_ADD_ISSUES';
export const SUPERADMIN_GET_ALL_SUGGESTIONS = 'SUPERADMIN_GET_ALL_SUGGESTIONS';
export const SUPERADMIN_CHANGE_SUGGESTION_STATUS =
  'SUPERADMIN_CHANGE_SUGGESTION_STATUS';

export const SUPERADMIN_GET_ALL_DINER_ID = 'SUPERADMIN_GET_ALL_DINER_ID';
export const SUPERADMIN_GET_GLOBAL_CATALOG = 'SUPERADMIN_GET_GLOBAL_CATALOG';
export const SUPERADMIN_GET_CHAIN_CATALOG = 'SUPERADMIN_GET_CHAIN_CATALOG';
export const EDIT_GLOBAL_CATALOG = 'EDIT_GLOBAL_CATALOG';
export const EDIT_CHAIN_CATALOG = 'EDIT_CHAIN_CATALOG';
export const GET_ADMIN_MENU_CATEGORY = 'GET_ADMIN_MENU_CATEGORY';
export const GET_ADMIN_MENU_CATEGORY_ITEMS = 'GET_ADMIN_MENU_CATEGORY_ITEMS';
export const SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP =
  'SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP';
export const SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN =
  'SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN';
export const GET_ADMIN_GLOBAL_ALL_MENU_ITEMS =
  'GET_ADMIN_GLOBAL_ALL_MENU_ITEMS';
export const GLOBAL_ADD_CATALOG_ACTIVE_DATA = 'GLOBAL_ADD_CATALOG_ACTIVE_DATA';
export const GET_ADMIN_ADDED_TEMPLATES_GLOBAL =
  'GET_ADMIN_ADDED_TEMPLATES_GLOBAL';

export const GET_ADMIN_ADDED_TEMPLATES_CHAIN =
  'GET_ADMIN_ADDED_TEMPLATES_CHAIN';
export const GET_ALL_EVENTS_ADMIN = 'GET_ALL_EVENTS_ADMIN';
export const GET_ONLINE_EVENT = 'GET_ONLINE_EVENT';
export const EVENT_DETAILS_ADMIN = 'EVENT_DETAILS_ADMIN';
export const ADMIN_EDIT_EVENT_DETAILS_ADMIN = 'ADMIN_EDIT_EVENT_DETAILS_ADMIN';

export const SET_CATEGORY_CHAIN_DATE = 'SET_CATEGORY_CHAIN_DATE';

/***************************************************************
 * @DESC SUPER ADMIN REFERRALS
 **************************************************************/
export const SUPER_ADMIN_REFREES = 'SUPER_ADMIN_REFREES';
export const SUPER_ADMIN_REFERRALS = 'SUPER_ADMIN_REFERRALS';
export const SUPER_ADMIN_VENDOR_REFERRALS = 'SUPER_ADMIN_VENDOR_REFERRALS';
export const SUPER_ADMIN_SALES_REFERRALS = 'SUPER_ADMIN_SALES_REFERRALS';
export const SUPER_ADMIN_AFFILIATES_REFERRALS =
  'SUPER_ADMIN_AFFILIATES_REFERRALS';
export const SUPER_ADMIN_PARTNERS_REFERRALS = 'SUPER_ADMIN_PARTNERS_REFERRALS';
export const SUPER_ADMIN_REFERRAL_CODES = 'SUPER_ADMIN_REFERRAL_CODES';

/***************************************************************
 * @DESC SUPER ADMIN REFERRALS
 **************************************************************/

export const USER_WALLET_TRANSACTIONS_MAIN = 'USER_WALLET_TRANSACTIONS_MAIN';
export const USER_WALLET_TRANSACTIONS = 'USER_WALLET_TRANSACTIONS';
export const SUPER_ADMIN_ROLES = 'SUPER_ADMIN_ROLES';
export const ADMIN_SCAN_PAY = 'ADMIN_SCAN_PAY';
export const GET_ALL_DONATIONS = 'GET_ALL_DONATIONS';
export const GET_ALL_DONATIONS_REPORT = 'GET_ALL_DONATIONS_REPORT';
export const GET_ALL_VENDOR_SETTLEMENT = 'GET_ALL_VENDOR_SETTLEMENT';
export const GET_ALL_VENDOR_STATEMENT = 'GET_ALL_VENDOR_STATEMENT';
export const SINGLE_VENDOR_SETTLEMENT = 'SINGLE_VENDOR_SETTLEMENT';
export const SINGLE_VENDOR_STATEMENT = 'SINGLE_VENDOR_STATEMENT';
export const GET_PAYMENT_HISTORY = 'GET_PAYMENT_HISTORY';

/***************************************************************
 * @DESC VENDOR REFERRALS
 **************************************************************/
export const VEDNOR_REFERRALS = 'VEDNOR_REFERRALS';

/***************************************************************
 * @DESC VENDOR ROLE MANAGEMENT
 **************************************************************/
export const VENDOR_ROLES_GET = 'VENDOR_ROLES_GET';

/***************************************************************
 * @DESC Subscription Menu Setup
 **************************************************************/

export const GET_VENDOR_MENU_CATEGORY = 'GET_VENDOR_MENU_CATEGORY';
export const GET_VENDOR_MENU_CATEGORY_ITEMS = 'GET_VENDOR_MENU_CATEGORY_ITEMS';
export const SET_ACTIVE_ITEM_ID_MENU_SETUP = 'SET_ACTIVE_ITEM_ID_MENU_SETUP';
export const SET_ACTIVE_ITEM_ID_MENU_SETUP_DATA =
  'SET_ACTIVE_ITEM_ID_MENU_SETUP_DATA';
export const GET_VENDOR_ADDED_TEMPLATES = 'GET_VENDOR_ADDED_TEMPLATES';
export const GET_VENDOR_ADDED_TEMPLATES_ALL = 'GET_VENDOR_ADDED_TEMPLATES_ALL';
export const SET_ACTIVE_CATEGORY_DATA_MENU_SETUP =
  'SET_ACTIVE_CATEGORY_DATA_MENU_SETUP';
export const GET_VENDOR_ALL_MENU_ITEMS = 'GET_VENDOR_ALL_MENU_ITEMS';
export const GET_LOCAL_CATALOG_DATA = 'GET_LOCAL_CATALOG_DATA';
export const GET_LOCAL_ITEMS_DATA = 'GET_LOCAL_ITEMS_DATA';
export const ACTIVE_CATALOG_NAME = 'ACTIVE_CATALOG_NAME';
export const ACTIVE_CATALOG_ID = 'ACTIVE_CATALOG_ID';
export const SELECTED_CATALOG_ITEMS = 'SELECTED_CATALOG_ITEMS';
export const SELECTED_ITEMS_ID = 'SELECTED_ITEMS_ID';
export const CATALOG_SELECTED_CATEGORIES_ITEMS =
  'CATALOG_SELECTED_CATEGORIES_ITEMS';
export const SET_PRODUCT_CLASSIFCATION = 'SET_PRODUCT_CLASSIFCATION';
export const SET_PRODUCT_ACTIVE_CATID = 'SET_PRODUCT_ACTIVE_CATID';
export const REORDER_VENDOR_MENU_CATEGORY = 'REORDER_VENDOR_MENU_CATEGORY';
export const REORDER_VENDOR_MENU_ITEM = 'REORDER_VENDOR_MENU_ITEM';
export const REORDER_VENDOR_MENU_ITEM_STATUS =
  'REORDER_VENDOR_MENU_ITEM_STATUS';
export const GET_MENU_SETUP_CATEGORY_ALL = 'GET_MENU_SETUP_CATEGORY_ALL';
export const GET_CUSTOM_MENU_LIST = 'GET_CUSTOM_MENU_LIST';
export const ACTIVE_MENU = 'ACTIVE_MENU';

/*************************************************************
 * @DESC VENDOR REPORTS DASHBOARD
 *************************************************************/
export const GET_REPORT_RESTAURANT = 'GET_REPORT_RESTAURANT';
export const GET_REPORT_BY_SERVICE = 'GET_REPORT_BY_SERVICE';
export const GET_REPORT_BY_TYPE = 'GET_REPORT_BY_TYPE';
export const GET_SETTLEMENT_REPORT = 'GET_SETTLEMENT_REPORT';
export const GET_ORDER_ITEM_TAX = 'GET_ORDER_ITEM_TAX';
export const GET_PAYMENT_ORDER = 'GET_PAYMENT_ORDER';
export const GET_PAYMENT_EVENT = 'GET_PAYMENT_EVENT';
export const GET_PAYMENT_SCAN = 'GET_PAYMENT_SCAN';
export const GET_INVOICE = 'GET_INVOICE';
export const GET_SCAN_AND_PAY_ACTIVITY = 'GET_SCAN_AND_PAY_ACTIVITY';
export const GET_EVENT = 'GET_EVENT';
export const GET_ALL_ORDER = 'GET_ALL_ORDER';

/*************************************************************
 * @DESC RSVP EVENT DASHBOARD
 *************************************************************/
export const GET_SINGLE_RSVP_EVENT_INFORMATION =
  'GET_SINGLE_RSVP_EVENT_INFORMATION';
export const GET_SINGLE_RSVP_EVENT_PENDING = 'GET_SINGLE_RSVP_EVENT_PENDING';
export const GET_SINGLE_RSVP_EVENT_RSVP = 'GET_SINGLE_RSVP_EVENT_RSVP';
export const GET_SINGLE_RSVP_EVENT_TICKET = 'GET_SINGLE_RSVP_EVENT_TICKET';
export const GET_SINGLE_RSVP_EVENT_HISTORY = 'GET_SINGLE_RSVP_EVENT_HISTORY';
export const GET_SINGLE_RSVP_EVENT_ALL = 'GET_SINGLE_RSVP_EVENT_ALL';
export const TRANSACTION_ID = 'TRANSACTION_ID';
export const SET_ONLINE_EVENT_DETAILS_VENDOR =
  'SET_ONLINE_EVENT_DETAILS_VENDOR';
export const GET_ONLINE_EVENT_DETAILS_VENDOR =
  'GET_ONLINE_EVENT_DETAILS_VENDOR';

/*************************************************************
 * @DESC DISTANCE FOR USER TRACKING
 *************************************************************/
export const DISTANCE_MATRIX = 'DISTANCE_MATRIX';

/*************************************************************
 * @DESC HELP AND FAQ REDUCERS
 *************************************************************/
export const GET_SUB_CATEGORY_HELP_FAQ = 'GET_SUB_CATEGORY_HELP_FAQ';
export const GET_VENDOR_HELP_FAQ = 'GET_VENDOR_HELP_FAQ';
export const GET_SETTLEMENT_TYPE_REPORT = 'GET_SETTLEMENT_TYPE_REPORT';

/*************************************************************
 * @DESC SUPER ADMIN ONBOARDING REDUCERS
 *************************************************************/
export const ADMIN_ONBOARD_SET_CURRENT_USER = 'ADMIN_ONBOARD_SET_CURRENT_USER';
export const ADMIN_ONBOARD_SET_CURRENT_USER_DECODED_TOKEN =
  'ADMIN_ONBOARD_SET_CURRENT_USER_DECODED_TOKEN';

export const ADMIN_ONBOARD_UPDATE_SUBSCRIPTION_TYPE =
  'ADMIN_ONBOARD_UPDATE_SUBSCRIPTION_TYPE';
export const ADMIN_ONBOARD_SET_CURBSIDE_LOCATION =
  'ADMIN_ONBOARD_SET_CURBSIDE_LOCATION';
export const ADMIN_ONBOARD_SET_CURBSIDE_LOCATION_ARR =
  'ADMIN_ONBOARD_SET_CURBSIDE_LOCATION_ARR';
export const ADMIN_ONBOARD_SET_FASTFOOD_CURBSIDE_LOCATION_ARR =
  'ADMIN_ONBOARD_SET_FASTFOOD_CURBSIDE_LOCATION_ARR';
export const ADMIN_ONBOARD_SET_MULTISERVICE_CURBSIDE_LOCATION_ARR =
  'ADMIN_ONBOARD_SET_MULTISERVICE_CURBSIDE_LOCATION_ARR';

export const ADMIN_ONBOARD_SET_PLACE_ID = 'ADMIN_ONBOARD_SET_PLACE_ID';
export const ADMIN_ONBOARD_SET_PLACE_ID_MARKER =
  'ADMIN_ONBOARD_SET_PLACE_ID_MARKER';
export const ADMIN_ONBOARD_GET_MARKER_POSITION =
  'ADMIN_ONBOARD_GET_MARKER_POSITION';
export const ADMIN_ONBOARD_GET_OPEN_RESTAURANT_STATUS =
  'ADMIN_ONBOARD_GET_OPEN_RESTAURANT_STATUS';
export const ADMIN_ONBOARD_SET_RESTAURANT_DETAILS =
  'ADMIN_ONBOARD_SET_RESTAURANT_DETAILS';
export const ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS =
  'ADMIN_ONBOARD_SET_RESTAURANT_SUBSCRIPTION_DETAILS';
export const ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY =
  'ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY';
export const ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY_ITEMS =
  'ADMIN_ONBOARD_GET_VENDOR_MENU_CATEGORY_ITEMS';
export const ADMIN_ONBOARD_SET_PRODUCT_CLASSIFCATION =
  'ADMIN_ONBOARD_SET_PRODUCT_CLASSIFCATION';
export const ADMIN_ONBOARD_SET_ACTIVE_ITEM_ID_MENU_SETUP =
  'ADMIN_ONBOARD_SET_ACTIVE_ITEM_ID_MENU_SETUP';
export const ADMIN_ONBOARD_GET_VENDOR_ADDED_TEMPLATES =
  'ADMIN_ONBOARD_GET_VENDOR_ADDED_TEMPLATES';
export const ADMIN_ONBOARD_SET_ACTIVE_CATEGORY_DATA_MENU_SETUP =
  'ADMIN_ONBOARD_SET_ACTIVE_CATEGORY_DATA_MENU_SETUP';
export const ADMIN_ONBOARD_GET_VENDOR_ALL_MENU_ITEMS =
  'ADMIN_ONBOARD_GET_VENDOR_ALL_MENU_ITEMS';
export const ADMIN_ONBOARD_GET_LOCAL_CATALOG_DATA =
  'ADMIN_ONBOARD_GET_LOCAL_CATALOG_DATA';
export const ADMIN_ONBOARD_ACTIVE_CATALOG_NAME =
  'ADMIN_ONBOARD_ACTIVE_CATALOG_NAME';
export const ADMIN_ONBOARD_ACTIVE_CATALOG_ID =
  'ADMIN_ONBOARD_ACTIVE_CATALOG_ID';
export const ADMIN_ONBOARD_SELECTED_ITEMS_ID =
  'ADMIN_ONBOARD_SELECTED_ITEMS_ID';
export const ADMIN_ONBOARD_SELECTED_CATALOG_ITEMS =
  'ADMIN_ONBOARD_SELECTED_CATALOG_ITEMS';
export const ADMIN_ONBOARD_CATALOG_SELECTED_CATEGORIES_ITEMS =
  'ADMIN_ONBOARD_CATALOG_SELECTED_CATEGORIES_ITEMS';
export const ADMIN_ONBOARD_GET_LOCAL_ITEMS_DATA =
  'ADMIN_ONBOARD_GET_LOCAL_ITEMS_DATA';

/*************************************************************
 * @DESC SUPER ADMIN SMS EMAIL NOTIFICATION TEMPLATES REDUCERS
 *************************************************************/
export const GET_USER_VENDOR_TEMPLATES_DETAILS =
  'GET_USER_VENDOR_TEMPLATES_DETAILS';
export const GET_VENDOR_TEMPLATES_DETAILS = 'GET_VENDOR_TEMPLATES_DETAILS';
export const GET_USER_TEMPLATES_DETAILS = 'GET_USER_TEMPLATES_DETAILS';

export const GET_SMS_TEMPLATES = 'GET_SMS_TEMPLATES';
export const GET_EMAIL_TEMPLATES = 'GET_EMAIL_TEMPLATES';
export const GET_NOTIFICATION_TEMPLATES = 'GET_NOTIFICATION_TEMPLATES';
export const GET_IN_APP_TEMPLATES = 'GET_IN_APP_TEMPLATES';
export const UPDATE_IN_APP_TEMPLATES = 'UPDATE_IN_APP_TEMPLATES';
export const EDIT_IN_APP_TEMPLATES = 'EDIT_IN_APP_TEMPLATES';
export const GET_SINGLE_TEMPLATES = 'GET_SINGLE_TEMPLATES';

/*************************************************************
 * @DESC SUPER ADMIN ACTIVITY REPORTS REDUCERS
 *************************************************************/
export const GET_PENDING_ACTIVITY_SUMMARY = 'GET_PENDING_ACTIVITY_SUMMARY';
export const GET_SEATING_ACTIVITY_SUMMARY = 'GET_SEATING_ACTIVITY_SUMMARY';
export const GET_ALL_SEATING_DASHBOARD_SUMMARY =
  'GET_ALL_SEATING_DASHBOARD_SUMMARY';
export const GET_ALL_COUNT_SUMMARY_REPORTS = 'GET_ALL_COUNT_SUMMARY_REPORTS';
export const GET_ALL_VENDOR_SEATING_DINER_RECORDS =
  'GET_ALL_VENDOR_SEATING_DINER_RECORDS';
export const GET_ALL_VENDOR_PENDING_DINER_RECORDS =
  'GET_ALL_VENDOR_PENDING_DINER_RECORDS';
export const GET_ALL_VENDOR_RESERVATION_DINER_RECORDS =
  'GET_ALL_VENDOR_RESERVATION_DINER_RECORDS';
export const GET_ALL_VENDOR_HISTORY_DINER_RECORDS =
  'GET_ALL_VENDOR_HISTORY_DINER_RECORDS';
export const STORE_VENDOR_ID_SUPERADMIN = 'STORE_VENDOR_ID_SUPERADMIN';

/*************************************************************
 * @DESC SUPER ADMIN CHAIN MANAGEMENT REDUCES
 *************************************************************/
export const GET_ACTIVE_CHAINS = 'GET_ACTIVE_CHAINS';
export const GET_PENDING_CHAINS = 'GET_PENDING_CHAINS';
export const GET_ON_HOLD_CHAINS = 'GET_ON_HOLD_CHAINS';

/*************************************************************
 * @DESC SUPER ADMIN ORDERING ACTIVITY DASHBOARD
 *************************************************************/
export const ADMIN_GET_ALL_ORDER_ACTIVITY = 'ADMIN_GET_ALL_ORDER_ACTIVITY';
export const ADMIN_GET_ALL_PENDING_ACTIVITY = 'ADMIN_GET_ALL_PENDING_ACTIVITY';
export const ADMIN_GET_ALL_ORDERING_DASHBOARD =
  'ADMIN_GET_ALL_ORDERING_DASHBOARD';

/*************************************************************
 * @DESC SUPER ADMIN SHORT VIDEOS DASHBOARD
 *************************************************************/
export const ADMIN_SHORT_VIDEOS_GET = 'ADMIN_SHORT_VIDEOS_GET';
export const ADMIN_SHORT_VIDEOS_UPDATE_STATUS =
  'ADMIN_SHORT_VIDEOS_UPDATE_STATUS';
export const ADMIN_SHORT_VIDEOS_DELETE = 'ADMIN_SHORT_VIDEOS_DELETE';

/****************************************
 * @DESC VENDOR EARNINGS DASHBOARD
 ****************************************/
export const GET_ALL_VENDOR_EARNINGS = 'GET_ALL_VENDOR_EARNINGS';
export const GET_ALL_HISTORY_EARNINGS = 'GET_ALL_HISTORY_EARNINGS';

/****************************************
 * @DESC SUPER ADMIN WALLET DASHBOARD
 ***************************************/
export const GET_ALL_DEPARTMENTAL_MONEY_COUNT =
  'GET_ALL_DEPARTMENTAL_MONEY_COUNT';
export const GET_ALL_DEPARTMENTAL_MONEY_COUNT_DATA =
  'GET_ALL_DEPARTMENTAL_MONEY_COUNT_DATA';
export const GET_ALL_DEPARTMENTAL_MONEY_PENDING =
  'GET_ALL_DEPARTMENTAL_MONEY_PENDING';
export const GET_ALL_DEPARTMENTAL_PROCESS_APPROVED =
  'GET_ALL_DEPARTMENTAL_PROCESS_APPROVED';

export const GET_ALL_USER_WALLET_MONEY_COUNT =
  'GET_ALL_USER_WALLET_MONEY_COUNT';
export const GET_ALL_USER_MONEY_PENDING = 'GET_ALL_USER_MONEY_PENDING';
export const GET_ALL_USER_PROCESS_APPROVED = 'GET_ALL_USER_PROCESS_APPROVED';
export const GET_ALL_USER_REFERRALS = 'GET_ALL_USER_REFERRALS';
export const GET_ALL_TRANSFER_MONEY = 'GET_ALL_TRANSFER_MONEY';
export const GET_ALL_TRANSFER_MONEY_PROCESS = 'GET_ALL_TRANSFER_MONEY_PROCESS';

/************************************************
 * @DESC SUPER ADMIN WHOLE VIEW DASHBOARD START
 ***********************************************/
/***************** ON BOARD RESTAURANT DETAILS **************/
export const ADMIN_SET_VENDOR_ONBOARD_DETAILS =
  'ADMIN_SET_VENDOR_ONBOARD_DETAILS';
export const ADMIN_SET_VENDOR_ONBOARD_CHAIN = 'ADMIN_SET_VENDOR_ONBOARD_CHAIN';
export const ADMIN_SET_VENDOR_SUBCRIPTION = 'ADMIN_SET_VENDOR_SUBCRIPTION';

/***************** RESTAURANT SEATING DETAILS **************/
export const GET_ADMIN_WHOLE_VENDOR_DINER = 'GET_ADMIN_WHOLE_VENDOR_DINER';
export const GET_ADMIN_WHOLE_PENDING_DINER = 'GET_ADMIN_WHOLE_PENDING_DINER';
export const GET_ADMIN_WHOLE_RESERVATION_DINER =
  'GET_ADMIN_WHOLE_RESERVATION_DINER';
export const GET_ADMIN_WHOLE_RESERVATION_TIMING_SLOTS =
  'GET_ADMIN_WHOLE_RESERVATION_TIMING_SLOTS';
export const GET_ADMIN_WHOLE_HISTORY_DINER = 'GET_ADMIN_WHOLE_HISTORY_DINER';
export const SET_ADMIN_WHOLE_DINER_DETAILS = 'SET_ADMIN_WHOLE_DINER_DETAILS';
export const SET_ADMIN_WHOLE_VENDOR_TICKETS_USER_DETAILS =
  'SET_ADMIN_WHOLE_VENDOR_TICKETS_USER_DETAILS';
export const INC_ADMIN_WHOLE_SEATING_COUNT = 'INC_ADMIN_WHOLE_SEATING_COUNT';
export const DEC_ADMIN_WHOLE_SEATING_COUNT = 'DEC_ADMIN_WHOLE_SEATING_COUNT';

/************************************************
 * @DESC SUPER ADMIN WHOLE VIEW DASHBOARD END
 ***********************************************/

export const SET_VENDORACCESS = 'SET_VENDORACCESS';
export const CLEAR_VENDORACCESS = 'CLEAR_VENDORACCESS';

/******* Popup Notification ******************/
export const ADD_TO_POPUP = 'ADD_TO_POPUP';
export const REMOVE_FROM_POPUP = 'REMOVE_FROM_POPUP';

export const ADD_TO_ADMIN_POPUP = 'ADD_TO_ADMIN_POPUP';
export const REMOVE_FROM_ADMIN_POPUP = 'REMOVE_FROM_PADMIN_OPUP';

/****************************************************
 * @DESC MERCHANT ADD ITEM FROM GLOBAL CATELOGE
 ****************************************************/
export const SET_CURRENT_ITEM_CATEGORY = 'SET_CURRENT_ITEM_CATEGORY';
export const SET_CURRENT_ACTIVE_CATELOGE_ID = 'SET_CURRENT_ACTIVE_CATELOGE_ID';
export const GET_ALL_GLOBAL_CATELOGE = 'GET_ALL_GLOBAL_CATELOGE';
export const SET_CURRENT_ACTIVE_CATEGORY_ID = 'SET_CURRENT_ACTIVE_CATEGORY_ID';
export const GET_ALL_GLOBAL_CATELOGE_CATEGORY =
  'GET_ALL_GLOBAL_CATELOGE_CATEGORY';
export const GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM =
  'GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM';
export const SET_ALL_COMPLETE_ITEMS = 'SET_ALL_COMPLETE_ITEMS';

/***************************************************************
 * @DESC SUPER ADMIN PROMOTIONS
 **************************************************************/
export const SET_PROMOTIONAL_VIDEOS = 'SET_PROMOTIONAL_VIDEOS';
export const SET_REFERRAL_AND_CASHBACK = 'SET_REFERRAL_AND_CASHBACK';
export const GET_REFERRAL_AND_CASHBACK_ID = 'GET_REFERRAL_AND_CASHBACK_ID';
export const UPDATE_REFERRAL_AND_CASHBACK = 'UPDATE_REFERRAL_AND_CASHBACK_ID';
export const GET_USER_REGISTRATIONS = 'GET_USER_REGISTRATIONS';
export const BUSINESS_DETAILS_STEP = 'BUSINESS_DETAILS_STEP';
export const SUPERADMIN_DELETE_REFERRAL = 'SUPERADMIN_DELETE_REFERRAL';

/***************************************************************
 * @DESC SUPER ADMIN UOM MANAGEMENT SERVICES
 **************************************************************/
export const SET_UOM_MANAGEMENT = 'SET_UOM_MANAGEMENT';
export const SET_UOM_RATIO = 'SET_UOM_RATIO';
export const SET_UOM_RATIOTWO = 'SET_UOM_RATIOTWO';
export const SET_RATIO_CONVERSATION = 'SET_RATIO_CONVERSATION';

/***************************************************************
 * @DESC SUPER ADMIN MAINTAIN PROMOTION SERVICES
 **************************************************************/
export const SET_REQUESTED_PROMOTION = 'SET_REQUESTED_PROMOTION';
export const UPDATED_REQUESTED_PROMOTION = 'UPDATED_REQUESTED_PROMOTION';
export const SET_MAINTAIN_PROMOTION = 'SET_MAINTAIN_PROMOTION';
export const UPDATED_MAINTAIN_PROMOTION = 'UPDATED_MAINTAIN_PROMOTION';
export const SET_VALIDATE_PROMOTION = 'SET_VALIDATE_PROMOTION';
export const UPDATED_VALIDATE_PROMOTION = 'UPDATED_VALIDATE_PROMOTION';
export const SET_APPROVED_PROMOTION = 'SET_APPROVED_PROMOTION';
export const UPDATED_APPROVED_PROMOTION = 'UPDATED_APPROVED_PROMOTION';

/***************************************************************
 * @DESC SUPER ADMIN MAINTAIN ONLINE AND OFFLINE OFFERS
 **************************************************************/
export const SET_ONLINE_COUNTRY = 'SET_ONLINE_COUNTRY';
export const SET_ONLINE_STATE = 'SET_ONLINE_STATE';
export const SET_ONLINE_CITY = 'SET_ONLINE_CITY';
export const SET_ONLINE_OFFER_RESTAURANT = 'SET_ONLINE_OFFER_RESTAURANT';
export const SET_ONLINE_OFFER_SELECTED_RESTAURANT =
  'SET_ONLINE_OFFER_SELECTED_RESTAURANT';

/***************************************************************
 * @DESC SUPER ADMIN EXPERIENCE
 **************************************************************/

export const ADD_PAGE_EXPERIENCE = 'ADD_PAGE_EXPERIENCE';
export const GET_PAGE_EXPERIENCE = 'GET_PAGE_EXPERIENCE';
export const UPDATE_PAGE_EXPERIENCE = 'UPDATE_PAGE_EXPERIENCE';
export const EXPERIENCE_MANAGEMENT_DATA_ADMIN =
  'EXPERIENCE_MANAGEMENT_DATA_ADMIN';
export const EXPERIENCE_MANAGEMENT_ARCHIVED_DATA_ADMIN =
  'EXPERIENCE_MANAGEMENT_ARCHIVED_DATA_ADMIN';

/***************************************************************
 * @DESC MERCHANT DELIVERY PERSON RECORDS
 **************************************************************/
export const GET_DELIVERY_PERSON = 'GET_DELIVERY_PERSON';
export const SINGLE_DELIVERY_PERSON = 'SINGLE_DELIVERY_PERSON';
export const ADD_DELIVERY_PERSON = 'ADD_DELIVERY_PERSON';
